import { twMerge } from 'tailwind-merge';

export function CompanyLogo({
  imageUrl,
  className,
  fallbackClassName,
}: {
  imageUrl: string | undefined;
  className?: string;
  fallbackClassName?: string;
}) {
  return (
    <>
      {imageUrl ? (
        <div className={twMerge(['flex justify-center items-center px-6 h-12 w-full', className])}>
          <img src={imageUrl} alt='logo' className='object-contain h-full' />
        </div>
      ) : (
        <div className={twMerge(['flex justify-center items-center px-6 h-12 w-full', fallbackClassName])}>
          <img
            className='object-contain h-full'
            src='https://assets.seinterminal.com/images/logos/SEIN_Tech_Partners_Logo_Color.png'
            alt='Sein technology partners logo'
          />
        </div>
      )}
    </>
  );
}
